import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { LoadingCircular } from 'shared/ui-kit/LoadingCircular';

/** DOCS { https://github.com/ankeetmaini/react-infinite-scroll-component#readme } */

interface InfiniteScrollWrapperProps {
  isInfiniteScrollOn: boolean;
  lengthData: number;
  functionNext: any;
  children: any;
  hasFileReferenceMore: boolean;
  parentId: string;
}

export const InfiniteScrollWrapper = ({
  isInfiniteScrollOn,
  lengthData,
  functionNext,
  children,
  hasFileReferenceMore,
  parentId
}: InfiniteScrollWrapperProps) => {
  if (!isInfiniteScrollOn) return <>{children}</>;

  return (
    <div style={{ marginTop: '50px', width: '100%' }}>
      <InfiniteScroll
        dataLength={lengthData} //This is important field to render the next data
        next={functionNext}
        hasMore={hasFileReferenceMore}
        loader={
          <h4>
            <LoadingCircular size={20} color="main" />
          </h4>
        }
        scrollableTarget="scrollableDiv"
        endMessage={
          <p style={{ textAlign: 'center' }}>
            <b>Nothing to show here</b>
          </p>
        }
      >
        {children} {/** !!! DO NOT TOUCH !!! => It wraps the table */}
      </InfiniteScroll>
    </div>
  );
};

export default InfiniteScrollWrapper;
